// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .transform-field {
  width: 50px !important;
}
:host .functions {
  padding: 5px;
}
:host .functions .mat-icon {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/unit-config/dialogs/unit-config-channel-add-dialog/unit-config-channel-add-dialog.component.scss"],"names":[],"mappings":"AACC;EACC,sBAAA;AAAF;AAGC;EACC,YAAA;AADF;AAGE;EACC,eAAA;AADH","sourcesContent":[":host {\n\t.transform-field {\n\t\twidth: 50px !important;\n\t}\n\n\t.functions {\n\t\tpadding: 5px;\n\t\t\n\t\t.mat-icon {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
